import CustomHTTPService from './custom-http.service';
import EncodeDecodeType from '../enums/EncodeDecodeType';
import { globalConstants } from "../constants/globalConstants";
import GLOBAL_CONFIG from '../config/config';
import GlobalStoreService from "../services/global-store.service";
import PlatformType from '../enums/PlatformType';
import BotType from '../enums/BotType';

export default class ChatBotApiService {

    static getBaseApiUrl(botType) {
        let user_logged_in = false
        if (!GlobalStoreService.get("APP_CONTEXT") && GlobalStoreService.get('primaryNumber') && GlobalStoreService.get('currentNumber') && GlobalStoreService.get('isUserLoggedIn') && GlobalStoreService.get('loggedInToken')) {
            user_logged_in = true
        }
        if (!botType) {
            botType = GlobalStoreService.get("currentBotType");
        }
        return `${(user_logged_in) ? GLOBAL_CONFIG.baseUrlWithAuth : GLOBAL_CONFIG.baseUrlWithoutAuth}${GLOBAL_CONFIG.botTypeBaseUrl[botType]}/`;
    }

    static initiate(
        mobileNo,
        scenarioObject,
        initiateretry,
        botType) {

        // const url = `${ChatBotApiService.getBaseApiUrl()}initiateScenario`;
        const url = `initiateScenario`
        let data;
        if (initiateretry) {
            data = {
                scenario: scenarioObject,
                msisdn: mobileNo,
                scenarioActive: true,
                initiateRetry: initiateretry
            };
        } else {
            data = {
                scenario: scenarioObject,
                msisdn: mobileNo,
                scenarioActive: true
            };
        }

        return CustomHTTPService.post(url, data, {}, EncodeDecodeType.CHATBOT);
    }

    static chatInScenario(
        mobileNo,
        authtoken,
        Response,
        transactionid,
        ScenarioObject,
        enteredtext,
        initiateretry,
        botType,
        acceptParameters,
        dynamicParameters
    ) {
        const enteredTextLowerCase = enteredtext.toLowerCase();
        // const url = `${ChatBotApiService.getBaseApiUrl()}chatInScenario`;
        const url = `chatInScenario`
        let data;
        if (initiateretry) {
            data = {
                msisdn: mobileNo,
                authToken: authtoken,
                transactionId: transactionid,
                scenarioActive: true,
                enteredText: enteredTextLowerCase,
                scenario: ScenarioObject,
                initiateRetry: initiateretry,
                response: Response
            };
        } else if (!initiateretry) {
            data = {
                msisdn: mobileNo,
                authToken: authtoken,
                transactionId: transactionid,
                scenarioActive: true,
                enteredText: enteredTextLowerCase,
                scenario: ScenarioObject,
                response: Response,
                acceptParameters: acceptParameters,
                dynamicParameters: dynamicParameters
            };
        }
        return CustomHTTPService.post(url, data, {}, EncodeDecodeType.CHATBOT);
    }

    static chatOutScenario(enteredtext) {
        const enteredTextLowerCase = enteredtext.toLowerCase();
        // const url = `${ChatBotApiService.getBaseApiUrl()}chatOutScenario`;
        const url = `chatOutScenario`

        const data = {
            enteredText: enteredTextLowerCase
        };
        return CustomHTTPService.post(url, data, {}, EncodeDecodeType.CHATBOT);
    }

    static submitFeedback() {
        // const url = `${ChatBotApiService.getBaseApiUrl()}saveFeedback`;
        const url = `saveFeedback`
        const data = {
            customerNumber: "",
            timestamp: ""
        };
        return CustomHTTPService.post(url, data, null, EncodeDecodeType.CHATBOT);
    }

    static getSmartSearches(searchText) {
        const url = `${ChatBotApiService.getBaseApiUrl()}autoSuggest?text=${searchText}`;
        return CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT);
    }

    static getCountrySmartSearches(searchText) {
        const url = `${ChatBotApiService.getBaseApiUrl()}countrySuggest?text=${searchText}`;
        return CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT);
    }

    static getUserMsisdn(reqData) {
        // const url = `${ChatBotApiService.getBaseApiUrl()}authenticateUser`;
        const url = `authenticateUser`
        const data = {
            "x-bsy-did": reqData["x-bsy-did"],
            "x-bsy-utkn": reqData["x-bsy-utkn"],
            "x-bsy-dt": reqData["x-bsy-dt"]
        };
        return CustomHTTPService.post(url, data, null, EncodeDecodeType.CHATBOT);
    }

    static submitDffCall(reqData) {
        // const url = `${ChatBotApiService.getBaseApiUrl()}createServiceRequest`;
        const url = `createServiceRequest`
        const data = {
            tagging: reqData.crmCode,
            notes: reqData.notes,
            scenarioName: reqData.scenarioName,
            lob: "postpaid",
            source: "DTPSTCBOT",
            transactionId: reqData.transactionId,
            dffNameValuePairs: reqData.dffNameValuePairs,
            channel: "chatbot",
            locationSMS: false,
            smsTemplate: "",
            authToken: reqData.authToken
        };
        return CustomHTTPService.post(url, data, {}, EncodeDecodeType.CHATBOT);
    }

    static getSSOProfileInApp(reqData) {
        // const url = `${ChatBotApiService.getBaseApiUrl()}userProfile`;
        const url = `userProfile`
        const data = {
            "x-bsy-did": reqData["x-bsy-did"],
            "x-bsy-utkn": reqData["x-bsy-utkn"],
            "x-bsy-dt": reqData["x-bsy-dt"]
        };
        return CustomHTTPService.post(url, data, null, EncodeDecodeType.CHATBOT);
    }

    static getPostPaidBill(reqData) {
        // const url = `${ChatBotApiService.getBaseApiUrl()}userProfile`;
        const url = `fetchPostPaidBill `;

        const data = reqData
        return CustomHTTPService.post(url, data, {}, EncodeDecodeType.CHATBOT);
    }

    static getDefaultPostpaidScenarios() {
        const url = `${ChatBotApiService.getBaseApiUrl(BotType.POSTPAID)}welcomeConfiguration`;
        return CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT);
    };

    static getDefaultPrepaidScenarios() {
        const url = `${ChatBotApiService.getBaseApiUrl(BotType.PREPAID)}welcomeConfiguration`;
        return CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT);
    };

    static getBotTypeDefaultScenarios(botType) {
        const url = `${ChatBotApiService.getBaseApiUrl(botType)}welcomeConfiguration`;
        return CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT);
    }

    static getOptionsCategories() {
        const url = `${ChatBotApiService.getBaseApiUrl()}categoryFetch`;
        return CustomHTTPService.get(url, {}, EncodeDecodeType.CHATBOT);
    };

    static getChatToken() {
        const botType = GlobalStoreService.get("currentBotType");
        const url = `${GLOBAL_CONFIG.baseUrlWithoutAuth}${GLOBAL_CONFIG.botTypeBaseUrl[botType]}/chatToken`;
        const data = {
            "grant_type": "password",
            "authSource": "BASIC"
        };
        const config = {
            headers: {
                "Authorization": "Basic Y2hhdGJvdF91aV9jbGllbnQ6Y2hhdGJvdF91aV9jbGllbnQ=",
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }
        return CustomHTTPService.post(url, data, config, EncodeDecodeType.URL_FORM_ENCODED);
    }

    static getChatTokenForWeb(reqData) {

        // const url = `https://www.airtel.in/ds2/chatbotstage/chatMediator/chatToken`;
        const url = `${GLOBAL_CONFIG.baseUrlWithAuth}chatMediator/chatToken`;

        const data = {
            "grant_type": "password",
            "authSource": "AIRTEL_WEB",
            "client_id": 'chatbot_ui_client',
            "client_secret": 'chatbot_ui_client'
        };

        const config = {
            headers: {
                // "Authorization": "Basic Y2hhdGJvdF91aV9jbGllbnQ6Y2hhdGJvdF91aV9jbGllbnQ=",
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }
        return CustomHTTPService.post(url, data, config, EncodeDecodeType.URL_FORM_ENCODED);
    }

    static getChatTokenForApp(reqData) {
        const url = `${GLOBAL_CONFIG.baseUrlWithoutAuth}chatMediator/chatToken`;
        const data = {
            "grant_type": "password",
            "authSource": "AIRTEL_APP",
            "x-bsy-dt": reqData["x-bsy-dt"],
            "x-bsy-did": reqData["x-bsy-did"],
            "x-bsy-utkn1": reqData["x-bsy-utkn1"],
            "x-bsy-utkn2": reqData["x-bsy-utkn2"],
        };
        const config = {
            headers: {
                "Authorization": "Basic Y2hhdGJvdF91aV9jbGllbnQ6Y2hhdGJvdF91aV9jbGllbnQ=",
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }
        return CustomHTTPService.post(url, data, config, EncodeDecodeType.URL_FORM_ENCODED);
    }
}


// WEBPACK FOOTER //
// ./src/services/chatbot-api.service.js